<template>
    <div class="report-container">
        <div class="card-container">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <p>将汇总以下统计数据生成Word版录取报告：省份分布、专业分布、批次志愿统计、成绩统计、生源高中、生源类别、生源民族</p>
            </div>

            <el-form :model="form" label-width="120px">
                <el-form-item label="报告标题">
                    <el-input v-model="form.title" placeholder="请输入报告标题"></el-input>
                </el-form-item>

                <el-form-item label="包含内容">
                    <el-checkbox-group v-model="form.contents">
                        <el-checkbox label="province">省份分布</el-checkbox>
                        <el-checkbox label="major">专业分布</el-checkbox>
                        <el-checkbox label="batch">批次志愿统计</el-checkbox>
                        <el-checkbox label="score">成绩统计</el-checkbox>
                        <el-checkbox label="school">生源高中</el-checkbox>
                        <el-checkbox label="type">生源类别</el-checkbox>
                        <el-checkbox label="nation">生源民族</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleGenerate" :loading="generating">生成报告</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';

    export default {
        name: 'GenerateReport',
        inject: ['getCurrentYear'],
        data() {
            return {
                form: {
                    title: '',
                    contents: ['province', 'major', 'batch', 'score', 'school', 'type', 'nation']
                },
                generating: false
            };
        },
        methods: {
            handleGenerate() {
                const that = this;
                that.generating = true;

                const api_name = '/Analysis/GenerateReport';
                const url = TYBM_Env.GetApiUrl(api_name);

                // 构建查询参数
                const params = [];
                params.push('title=' + encodeURIComponent(that.form.title));
                params.push('contents=' + encodeURIComponent(that.form.contents.join(',')));

                const fullUrl = url + '?' + params.join('&');

                // 直接下载
                window.open(fullUrl, '_blank');
                that.generating = false;
            },
            updateTitle(year) {
                this.form.title = year + '年招生录取数据分析报告';
            }
        },
        created() {
            this.$root.$on('global-year-change', this.updateTitle);
        },
        beforeDestroy() {
            this.$root.$off('global-year-change', this.updateTitle);
        },
        mounted() {
            this.updateTitle(this.$root.currentYear || 2026);
        }
    };
</script>

<style scoped>
    .info-box {
        padding: 16px;
        border-radius: 4px;
        margin-bottom: 24px;
        border-left: 4px solid #1890ff;
        background-color: #e6f7ff;
        color: #0050b3;
        display: flex;
        gap: 12px;
    }
</style>

